import { ThemeOptions, ThemeProvider } from '@material-ui/core/styles';
import React, { createContext, Dispatch, SetStateAction, useState } from 'react';
import theme from '../theme';

interface IProps {
  children: JSX.Element;
}

const ThemeContextComponent = (props: IProps): JSX.Element => {
  const [themeOptions, setThemeOptions] = useState<ThemeOptions>(theme.getTheme());
  return (
    <ThemeContext.Provider value={setThemeOptions}>
      <ThemeProvider theme={themeOptions}>{props.children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const ThemeContext = createContext<Dispatch<SetStateAction<ThemeOptions>>>(() => ({}));

export default ThemeContextComponent;
